export const APP_PERMS_VIEW_INTERFACES = [
    {
        code: "AS",
        name: "applicationPermsViewDet.appSettings"
    },
    {
        code: "HL",
        name: "applicationPermsViewDet.highlights",
        parentCode: "AS"
    },
    {
        code: "WS",
        name: "applicationPermsViewDet.workSchedule",
        parentCode: "AS"
    },
    {
        code: "GR",
        name: "applicationPermsViewDet.manageAppGr",
        parentCode: "AS"
    },
    {
        code: "PE",
        name: "applicationPermsViewDet.managePerms",
        parentCode: "AS"
    },
    {
        code: "UA",
        name: "applicationPermsViewDet.updateApp",
        parentCode: "AS"
    },
    {
        code: "EX",
        name: "applicationPermsViewDet.exportApp",
        parentCode: "AS"
    },
    {
        code: "DI",
        name: "applicationPermsViewDet.diagrams"
    },
    {
        code: "SC",
        name: "applicationPermsViewDet.smartConDes"
    },
    {
        code: "IB",
        name: "applicationPermsViewDet.interfaceBuilder"
    },
    {
        code: "DB",
        name: "applicationPermsViewDet.docBuilder"
    },
    {
        code: "PB",
        name: "applicationPermsViewDet.perspectiveBuilder"
    },
    {
        code: "AP",
        name: "applicationPermsViewDet.apis"
    },
    {
        code: "DM",
        name: "applicationPermsViewDet.dataModel"
    },
    {
        code: "CAT",
        name: "applicationPermsViewDet.catalogs"
    },
    {
        code: "CS",
        name: "applicationPermsViewDet.catalogDef",
        parentCode: "CAT"
    },
    {
        code: "CD",
        name: "applicationPermsViewDet.catalogValues",
        parentCode: "CAT"
    },
    {
        code: "RP",
        name: "applicationPermsViewDet.reports"
    },
    {
        code: "TI",
        name: "applicationPermsViewDet.instancesTasks",
        parentCode: "RP"
    },
    {
        code: "ST",
        name: "applicationPermsViewDet.statistics",
        parentCode: "RP"
    },
    {
        code: "PA",
        name: "applicationPermsViewDet.publish"
    }
];

export const PERMISSIONS_CODES = [
    "AS", "HL", "GR", "PE", "UA", "EX", "DI", "SC", "IB", "DB", "PB", "AP", "DM", "CAT", "CS", "CD", "RP", "TI", "ST", "RT", "UC", "WS", "PA"
];

export const PERMISSIONS_ROLES = [
    "OWNER",
    "INITIATOR",
    "EDITOR",
    "DIAGRAM_EDITOR",
    "SMART_CONTRACT_DESIGNER",
    "INTERFACES_MANAGER",
    "DOCUMENTS_MANAGER",
    "PERSPECTIVE_MANAGER",
    "ADMINISTRATOR",
    "REPORTS_VIEWER",
    "TASKS_MANAGER",
    "VIEWER",
    "DATA_MODEL_VIEWER",
    "DATA_MODEL_MANAGER",
    "CATALOGS_MANAGER",
    "API_MANAGER",
    "SIDEBAR",
    "SIDEBAR_DOCUMENTS",
    "SIDEBAR_COMMENTS",
    "SIDEBAR_TIMELINE",
    "SIDEBAR_TASK_INFORMATION",
    "PUBLISH_APP"
];

export const SIDEBAR_SUBROLES = ["SIDEBAR_DOCUMENTS", "SIDEBAR_COMMENTS", "SIDEBAR_TIMELINE", "SIDEBAR_TASK_INFORMATION"];

export const PERMISSIONS_TABS = ["building", "initiate", "tasks", "dataViews", "analytics", "settings"];

export const PERMISSIONS_TABS_ROLES = [
    { index: 0, code: "EDITOR" },
    { index: 0, code: "DIAGRAM_EDITOR" },
    { index: 0, code: "SMART_CONTRACT_DESIGNER" },
    { index: 0, code: "INTERFACES_MANAGER" },
    { index: 0, code: "DOCUMENTS_MANAGER" },
    { index: 0, code: "VIEWER" },
    { index: 0, code: "DATA_MODEL_VIEWER" },
    { index: 0, code: "PUBLISH_APP" },
    { index: 0, code: "DATA_MODEL_MANAGER" },
    { index: 0, code: "CATALOGS_MANAGER" },
    { index: 0, code: "API_MANAGER" },
    { index: 1, code: "INITIATOR" },
    { index: 2, code: "TASKS_MANAGER" },
    { index: 2, code: "SIDEBAR" },
    { index: 2, code: "SIDEBAR_DOCUMENTS" },
    { index: 2, code: "SIDEBAR_COMMENTS" },
    { index: 2, code: "SIDEBAR_TIMELINE" },
    { index: 2, code: "SIDEBAR_TASK_INFORMATION" },
    { index: 3, code: "PERSPECTIVE_MANAGER" },
    { index: 4, code: "REPORTS_VIEWER" },
    { index: 5, code: "ADMINISTRATOR" }
];

export const ROLES_CONSTRAINTS = [
    "INITIATOR",
    "TASKS_MANAGER",
    "SIDEBAR",
    "SIDEBAR_DOCUMENTS",
    "SIDEBAR_COMMENTS",
    "SIDEBAR_TIMELINE",
    "SIDEBAR_TASK_INFORMATION"
];
